import { TariffAxle, TariffBilling, TariffSurchargeType, TariffVehicleClass, TariffVolumeCategory, TransportTariff } from "../../../system/Domain";

export const axleLabels: Record<TariffAxle, string> = {
	OwnAxle: "Eigene Achse",
	ForeignAxle: "Fremdachse"
};

export const billingLabels: Record<TariffBilling, string> = {
	ByQuantity: "Nach Anzahl",
	ByVehicleClass: "Nach Fahrzeugklasse",
	ByVolumeCategory: "Nach Volumen",
	PerVehicle: "Pro Fahrzeug"
};

export const vehicleClassLabels: Record<TariffVehicleClass, string> = {
	Pkw: "PKW",
	Suv: "SUV",
	Lcv: "LCV"
};

export const volumeCategoryLabels: Record<TariffVolumeCategory, string> = {
	S: "S",
	M: "M",
	L: "L",
	XL: "XL"
};

export const surchargeLabels: Record<TariffSurchargeType, string> = {
	ShortTermPlate: "Kurzzeitkennzeichen",
	MissedTransport: "Fehlfahrt",
	Other: "Sonstiges"
};

export const maximumNumberOfVehicles = 8;

export const getRouteLabel = (tariff: TransportTariff) =>
	`${tariff.originCompound?.name ?? "PLZ-Gebiet"} → ${tariff.destinationCompound?.name ?? "PLZ-Gebiet"}`;
